import React, {Component} from 'react';
import QuotesList from '../QuotesList';
import quotes from '../../quotes_base';
import 'bootstrap/dist/css/bootstrap.css'
import './style.css'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSync } from '@fortawesome/free-solid-svg-icons'
const sync = <FontAwesomeIcon icon={faSync} size="1x" />

class App extends Component {
  render() {
    return (
      <div>
        <div className="container">
          <QuotesList quotes = {quotes} />
          <div className="d-block mt-4">
            <button className="btn d-block mx-auto" alt="Хочу ещё!" title="Хочу ещё!" onClick={this.refresh}>
              {sync}
            </button>
          </div>
        </div>
        <footer className="page-footer">
          <nav className="font-weight-light small text-right mx-auto pt-4" >
            <a href='&#109;&#97;i&#108;&#116;o&#58;mail&#64;&#108;%&#54;5%67&#37;6Do&#46;%&#55;2&#117;'>mail&#64;l&#101;gmo&#46;&#114;u</a>
          </nav>
        </footer>
      </div>
    )
  }

  refresh = function() {
    console.log('refresh');
    window.location.reload()
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App/index.js